"use strict";

exports.__esModule = true;
var _UndoController = require("./UndoController");
Object.keys(_UndoController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UndoController[key]) return;
  exports[key] = _UndoController[key];
});
var _UndoContext = require("./UndoContext");
Object.keys(_UndoContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UndoContext[key]) return;
  exports[key] = _UndoContext[key];
});